import { NameDisplay } from '@uplift/types';
import { restClient } from '../../client';

export type DisplayNameResponse = {
  data: NameDisplay;
};

export const getDisplayName = (userId?: string) => {
  if (!userId) {
    return null;
  }

  return restClient.request<DisplayNameResponse>(`/api/v1/user/${userId}/display_name`);
};
